module.exports = __webpack_public_path__ + "static/media/ankring.628ef344.svg";